import { LogLevel } from "typescript-logging"
import { Log4TSProvider } from "typescript-logging-log4ts-style"

import type { Logger } from "typescript-logging-log4ts-style"

// Use a global variable to persist the provider across HMR reloads
const globalForLogging = globalThis as unknown as { __logProvider?: Log4TSProvider }

if (!globalForLogging.__logProvider) {
  globalForLogging.__logProvider = Log4TSProvider.createProvider("Default", {
    channel: {
      type: "RawLogChannel",
      write: logMessage => {
        const message = `%c[${logMessage.logNames}] %c${logMessage.message}`
        const styles = ["font-weight: bold", "font-weight: normal"]
        const level = logMessage.level
        const args = logMessage.args || []

        const flatArgs = [message, ...styles, ...args].flat()

        if (logMessage.exception) {
          flatArgs.push(logMessage.exception)
        }

        if (level == LogLevel.Trace) {
          console.trace.apply(null, flatArgs)
        } else if (level == LogLevel.Debug) {
          console.debug.apply(null, flatArgs)
        } else if (level == LogLevel.Info) {
          console.info.apply(null, flatArgs)
        } else if (level == LogLevel.Warn) {
          console.warn.apply(null, flatArgs)
        } else if (level == LogLevel.Error) {
          console.error.apply(null, flatArgs)
        } else if (level == LogLevel.Fatal) {
          console.error.apply(null, flatArgs)
        } else if (level == LogLevel.Off) {
          // Do nothing
        }
      }
    },
    level: LogLevel.Trace,
    groups: [{
      identifier: "matchAll",
      expression: new RegExp(".+")
    }],
  })
}

const provider = globalForLogging.__logProvider

export function getLogger(name: string): Logger {
  return provider.getLogger(name)
}
